// extracted by mini-css-extract-plugin
export default {"Tab":"tab_Tab__2VeEX","activeTab":"tab_activeTab__18VOE"};